import SaveIcon from '@mui/icons-material/Save';
import { Button, ButtonProps, Stack } from '@mui/material';

import CancelButton from '@/components/atoms/CancelButton';
import { FooterMenu } from '@/components/molecules/admin/FooterMenu';

// フッター部分の削除メニュー
export const TemplateGroupFooterMenu = (props: {
  onSave: ButtonProps['onClick'];
  onCancel: ButtonProps['onClick'];
  canBind: boolean;
  canUnbind: boolean;
  onBind: ButtonProps['onClick'];
  onUnbind: ButtonProps['onClick'];
}) => (
  <FooterMenu>
    <Stack alignItems="center" spacing={1}>
      <Stack direction="row" spacing={1}>
        <Button onClick={props.onBind} disabled={props.canBind === false}>
          選択項目を連結
        </Button>
        <Button onClick={props.onUnbind} disabled={props.canUnbind === false}>
          連結を解除
        </Button>
      </Stack>
      <Stack direction="row" spacing={1}>
        <CancelButton onClick={props.onCancel} />
        <Button startIcon={<SaveIcon />} onClick={props.onSave} color="primary">
          グループ化設定を保存
        </Button>
      </Stack>
    </Stack>
  </FooterMenu>
);
